import { Reveal, ChapterLabel } from "./primitives";
import { SERVICES } from "../../data/site";

export const Services = () => {
  return (
    <section
      id="servizi"
      data-testid="services-section"
      className="relative bg-[#0A0A0A] px-5 py-24 md:px-10 md:py-32"
    >
      <div className="mx-auto max-w-[1400px]">
        <ChapterLabel number="02" title="I nostri servizi" />

        <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal
                key={s.id}
                delay={(i % 3) * 0.08}
                data-testid={`service-card-${s.id}`}
                className="group relative bg-[#0A0A0A] p-8 transition-colors duration-300 hover:bg-[#121212] md:p-10"
              >
                <span className="absolute right-6 top-6 font-mono-accent text-xs text-[#52525B]">
                  0{i + 1}
                </span>
                <Icon
                  className="mb-8 h-12 w-12 text-[#FAFAFA] transition-colors duration-300 group-hover:text-[#FF2A2A]"
                  strokeWidth={1.5}
                />
                <h3 className="mb-3 font-display text-2xl font-semibold uppercase tracking-tight text-[#FAFAFA]">
                  {s.title}
                </h3>
                <p className="font-body text-sm leading-relaxed text-[#A1A1AA]">
                  {s.desc}
                </p>
                <span className="mt-6 block h-px w-0 bg-[#FF2A2A] transition-all duration-500 group-hover:w-16" />
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
